import type { CSSProperties, ReactNode } from 'react'

import styles from './Button.module.css'
import { Focusable } from './Focusable'

interface ButtonProps {
  children: ReactNode
  onPress?: (() => void) | undefined
  /** Handler pra setas — return false consome evento (não vaza pro Norigin). */
  onArrowPress?: ((dir: 'up' | 'down' | 'left' | 'right') => boolean) | undefined
  /** Auto-scroll do item pra dentro do viewport quando focado. Default true. */
  scrollOnFocus?: boolean | undefined
  variant?: 'primary' | 'secondary' | 'ghost' | undefined
  fullWidth?: boolean | undefined
  focusKey?: string | undefined
  style?: CSSProperties | undefined
}

export function Button({
  children,
  onPress,
  onArrowPress,
  scrollOnFocus,
  variant = 'primary',
  fullWidth,
  focusKey,
  style,
}: ButtonProps) {
  return (
    <Focusable
      focusKey={focusKey}
      onEnterPress={onPress}
      onArrowPress={onArrowPress}
      scrollOnFocus={scrollOnFocus}
      className={`${styles.btn} ${styles[variant]!} ${fullWidth ? styles.full : ''}`}
      style={style}
    >
      {children}
    </Focusable>
  )
}
